import { api } from '@/utils/fetch'

/** 查询简单行业动态/曝光台列表 */
const querySimpleIndustryDynamics = params => api('/index/querySimpleIndustryDynamics.do', params)

/** 查询政策法规列表 */
const querySimpleLaws = params => api('/index/querySimpleLaws.do', params)

/** 查询行业动态/曝光台详情 */
const queryIndustryDynamicDetails = params => api('/index/getIndustryDynamicDetails.do', params, 'get')

/** 查询政策法规详情 */
const queryGetLawDetails = params => api('/index/getLawDetails.do', params, 'get')

/** 查询全部区域列表 */
const queryIndexOrignList = params => api('/index/indexOrignList.do', params)

/** 查询驾校列表||首页驾校查询 */
const queryTrainingSchoolList = params => api('/index/queryTrainingSchoolList.do', params)

/** 查询官网驾校信息 */
const queryGetSchoolDetailById = params => api('/index/getSchoolDetailById.do', params, 'get')

/** 查询驾校场地图片列表 */
const queryGetSiteBySchoolId = params => api('/index/getSiteBySchoolId.do', params, 'get')

/** 查询驾校教练员详情 */
const queryQueryList = params => api('/coach/manage/queryList.do', params, 'get')

/** 根据驾校查询班型列表 */
const queryTrainingClasss = params => api('/index/getTrainingClasss.do', params, 'get')

/** 地图驾校搜索 */
const queryGetSchoolByName = params => api('/index/getSchoolByName.do', params, 'get', false)

/** 创建投诉咨询 */
const queryCreateComplaint = params => api('/index/createComplaint.do', params)

/** 首页驾培统计 */
const queryIndexCollectList = params => api('/index/indexCollectList.do', params, 'post', false)

/** 查询体检地址列表 */
const queryGetHospitalList = params => api('/index/getHospitalList.do', params, 'get')

/** 查询体检地址列表无loading */
const queryNoLoadingGetHospitalList = params => api('/index/getHospitalList.do', params, 'get', false)

/** 根据区域分组查询驾校数量 */
const queryIndexSchoolGroupList = params => api('/index/indexSchoolGroupList.do', params, 'get')

/** 学车须知或者驾驶常识列表接口 */
const queryEssayList = params => api('/ar/essay/essayList.do', params, 'get')

/** 学车须知或者驾驶常识详情接口 */
const queryEssayDetail = params => api('/ar/essay/essayDetail.do', params, 'get')

/** 首页评价 */
const queryHomeEvaluate = params => api('/index/evaluate', params, 'get')

/** 获取章节目录 */
const queryGetChapterList = params => api('/index/theoryCenter/getChapterList', params, 'get')

/** 获取模拟考试题 */
const queryGetMockExam = params => api('/index/theoryCenter/getMockExam', params, 'get')

/** 通过条件获取题目ID列表 */
const queryGetQuestionIdList = params => api('/index/theoryCenter/getQuestionIdList', params, 'get')

/** 通过id获取题目 */
const queryGetQuestionById = params => api('/index/theoryCenter/getQuestionById', params, 'get')

/**  */
const getTestCenterList = params => api('/index/theoryCenter/getTestCenterList', params, 'get')
//http://localhost:9100/gzpt/index/theoryCenter/getTestCenterList?carType=car&stepType=1

/** 公示栏 */
const queryPublicNotice = params => api('/index/queryPublicNotice.do', params, 'post', false)
/** 公示栏详情 */
const getPublicNoticeByDetails = params => api('/index/getPublicNoticeByDetails.do', params, 'post', false)



export {
  querySimpleIndustryDynamics,
  queryIndustryDynamicDetails,
  querySimpleLaws,
  queryGetLawDetails,
  queryIndexOrignList,
  queryTrainingSchoolList,
  queryGetSchoolDetailById,
  queryGetSiteBySchoolId,
  queryQueryList,
  queryTrainingClasss,
  queryGetSchoolByName,
  queryCreateComplaint,
  queryIndexCollectList,
  queryGetHospitalList,
  queryNoLoadingGetHospitalList,
  queryIndexSchoolGroupList,
  queryEssayList,
  queryEssayDetail,
  queryHomeEvaluate,
  queryGetChapterList,
  queryGetMockExam,
  queryGetQuestionIdList,
  queryGetQuestionById,
  getTestCenterList,
  queryPublicNotice,
  getPublicNoticeByDetails
}
